<script setup lang="ts">
import { onMounted, ref } from 'vue'
import type { GetSuiviCommandeViewModel, suiviCommandesSettings } from '@/lib/types'
import { generateField } from '@/lib/utils'
import SuiviCommandesRepository from '@/repository/SuiviCommandesRepository'
import { usePercentageMode } from '@/lib/usePercentageMode'
import CardInfoContent from '@/components/ui/card/CardInfoContent.vue'
import Card from '@/components/ui/card/Card.vue'

const fields = ref<{ label: string; value: number; percentage?: number; color?: string }[]>([])
const data = ref<GetSuiviCommandeViewModel | null>()
const settings = ref<suiviCommandesSettings | null>(null)
const { isPercentageMode } = usePercentageMode(false)

const updateInfoCardFields = () => {
  if (data.value && settings.value) {
    fields.value = [
      generateField(
        settings.value,
        data.value,
        'Nombre de propositions créées',
        'total_proposition_created',
      ),
      generateField(
        settings.value,
        data.value,
        'Propositions acceptées',
        'proposition_acceptees',
        undefined,
        'Propositions acceptées',
      ),
      generateField(
        settings.value,
        data.value,
        'Propositions en relance',
        'proposition_relance',
        undefined,
        'Propositions en relance',
      ),
      generateField(
        settings.value,
        data.value,
        'Propositions rejetées',
        'proposition_rejete',
        undefined,
        'Propositions rejetées',
      ),
    ]
  }
}

onMounted(async () => {
  data.value = await SuiviCommandesRepository.getInfoCardData()
  settings.value = await SuiviCommandesRepository.getSettings()
  updateInfoCardFields()
})
</script>

<template>
  <Card
    title="Suivi des commandes"
    :settings="settings"
    settings-url="api/widgets/card-suivi-commandes/settings"
    v-model:percentage-mode="isPercentageMode"
    :percent-icon="true"
  >
    <CardInfoContent :fields="fields || []" :skeletons="4" :percentage-mode="isPercentageMode" />
  </Card>
</template>
